import { useEffect } from "react";

import { useContentSelectors } from "../store/content/content.selectors";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useHTMLCode = () => {
  const { html } = useContentSelectors();

  const { getHTMLCode } = useDispatchedActions();

  useEffect(() => {
    if (!html) {
      getHTMLCode();
    }
    // eslint-disable-next-line
  }, [html]);
};
